import { apiGet, apiPost, apiPatch, apiDelete } from './httpClient'

export async function listRules(params = {}, signal) {
  const query = new URLSearchParams(params).toString()
  const data = await apiGet(`/rules/${query ? `?${query}` : ''}`, { signal })
  return Array.isArray(data) ? data : (data.results || [])
}

export async function createRule(data) {
  return apiPost('/rules/', data)
}

export async function updateRule(id, data) {
  return apiPatch(`/rules/${id}/`, data)
}

export async function deleteRule(id) {
  await apiDelete(`/rules/${id}/`)
  return true
}

export async function attachRuleToScenario(data) {
  return apiPost('/scenario-rules/', data)
}

export async function updateScenarioRule(id, data) {
  return apiPatch(`/scenario-rules/${id}/`, data)
}

export async function getRuleById(id, signal) {
  if (!id) {
    console.warn('getRuleById chamado sem ID');
    return null;
  }

  try {
    const data = await apiGet(`/rules/${id}/`, { signal });
    return data;
  } catch (error) {
    console.error(`Erro ao buscar regra com ID ${id}:`, error);
    return null;
  }
}